import svgIcons from '@images/icons.svg'

export default function icon(name, width = 24, height = 24) {
  return `<svg class="icon icon-${name}" width="${width}" height="${height}">
    <use xlink:href="${svgIcons}#${name}" />
  </svg>`
}
